import api from '../api/axios';

let cache: Record<string, string> | null = null;
let inFlight: Promise<Record<string, string>> | null = null;

// Normalizes whatever shape /api/settings/public actually returns (array of
// {key, value} objects, or a plain {key: value} map) into a flat lookup
// object. Never throws — any unexpected shape or network failure just
// results in an empty map, so callers always get a safe fallback instead
// of a crash.
export const getPublicSettings = async (): Promise<Record<string, string>> => {
  if (cache) return cache;
  if (inFlight) return inFlight;

  inFlight = (async () => {
    const map: Record<string, string> = {};
    try {
      const res = await api.get('/api/settings/public');
      const raw = res.data?.data ?? res.data;

      if (Array.isArray(raw)) {
        raw.forEach((s: any) => {
          if (s && typeof s.key === 'string') {
            map[s.key] = typeof s.value === 'string' ? s.value : String(s.value ?? '');
          }
        });
      } else if (raw && typeof raw === 'object') {
        Object.entries(raw).forEach(([k, v]) => {
          map[k] = typeof v === 'string' ? v : String(v ?? '');
        });
      }
    } catch {
      // network/auth failure — fall through with an empty map
    }
    cache = map;
    return map;
  })();

  return inFlight;
};

export const getPublicSetting = async (key: string, fallback: string): Promise<string> => {
  const settings = await getPublicSettings();
  return settings[key] || fallback;
};